import { IconArrowUp } from '@tabler/icons-react';
import { useRichTextEditorContext } from '@mantine/tiptap';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { canSplitTableUp } from 'pages/revisions-module/template-editor/editors/template/extensions/table-split';

/**
 * Splits the current table above the focused cell row.
 */
export default function TableSplitUp({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Rozdeliť tabuľku hore"
      icon={<IconArrowUp />}
      disabled={!canSplitTableUp(editor.state)}
      onClick={() => editor.chain().focus().splitTableUp().run()}
    />
  );
}
